export default __webpack_public_path__ + "static/media/judgesIcon.fedb75a6.svg";